import {userPreferencesHydratedAtom} from '@state'

import {useEffect} from 'react'

import {useSetAtom} from 'jotai'

export const useUserPreferencesHydration = () => {
  const setHydrated = useSetAtom(userPreferencesHydratedAtom)

  useEffect(() => {
    setHydrated(true)
  }, [])
}
